import { FlexProps, Box, Flex, Icon, Text, Badge } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';
import {
    Banknote,
    BookText,
    CalendarDays,
    ClipboardList,
    Cog,
    FileCheck2,
    LayoutGrid,
    LayoutPanelLeft,
    ListChecks,
    LogOut,
    LucideIcon,
    Phone,
    Settings,
    Stethoscope,
    UsersRound,
    Wallet,
    Sparkle,
    Brain,
} from 'lucide-react';

interface NavigationItemProps extends PropsWithChildren<FlexProps> {
    href: string;
    label: string;
    icon?: string;
    hideLabel?: boolean;
    activeMenuItem?: string;
    badge?: number;
}

const navigationIcons: { [index: string]: LucideIcon } = {
    dashboard: LayoutPanelLeft,
    patients: UsersRound,
    users: UsersRound,
    schedule: CalendarDays,
    callLog: Phone,
    staff: Stethoscope,
    qa: ListChecks,
    orders: ClipboardList,
    payroll: Banknote,
    cms: FileCheck2,
    billing: Wallet,
    organization: LayoutGrid,
    report: BookText,
    settings: Cog,
    logout: LogOut,
    auditLogs: Settings,
    featureFlags: Settings,
    enquiries: Sparkle,
    llmQuotas: Brain,
};

export function NavigationItem({ href, label, icon, hideLabel, activeMenuItem, badge, ...rest }: NavigationItemProps) {
    const NavIcon = icon ? navigationIcons[icon] : null;
    const isActive = activeMenuItem === href;

    return (
        <Link style={{ textDecoration: 'none', width: '100%' }} to={href}>
            <Box
                _focus={{ boxShadow: 'none' }}
                _hover={{
                    color: 'white',
                    backgroundColor: '#3b3449',
                    borderRadius: '2',
                }}
                className="group"
                backgroundColor={isActive ? '#3b3449' : 'transparent'}
                borderRadius={isActive ? '2' : 'initial'}
                px="10px">
                <Flex
                    align="flex-start"
                    cursor="pointer"
                    py="8px"
                    gap="8px"
                    alignItems="center"
                    borderRadius="var(--chakra-radii-base)"
                    {...rest}>
                    {NavIcon && (
                        <Icon
                            color={isActive ? 'white' : '#C3C1C8'}
                            h="24px"
                            w="24px"
                            _groupHover={{
                                color: 'white',
                            }}>
                            <NavIcon />
                        </Icon>
                    )}
                    {!hideLabel && (
                        <Flex align="center" gap={2} flex={1}>
                            <Text
                                fontWeight={500}
                                fontSize="sm"
                                color={isActive ? 'white' : '#C3C1C8'}
                                _groupHover={{
                                    color: 'white',
                                }}>
                                {label}
                            </Text>
                            {badge !== undefined && badge > 0 && (
                                <Badge size="sm" colorPalette="red" variant="solid" borderRadius="full">
                                    {badge}
                                </Badge>
                            )}
                        </Flex>
                    )}
                </Flex>
            </Box>
        </Link>
    );
}
